/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S1_TInputs */

const en_mk_abt_s1_t = /** @type {(inputs: Mk_Abt_S1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release 1.0 is live in production`)
};

const id_mk_abt_s1_t = /** @type {(inputs: Mk_Abt_S1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis 1.0 berjalan di produksi`)
};

/**
* | output |
* | --- |
* | "Release 1.0 is live in production" |
*
* @param {Mk_Abt_S1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s1_t = /** @type {((inputs?: Mk_Abt_S1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s1_t(inputs)
	return en_mk_abt_s1_t(inputs)
});